<section class="wagering-limits-screen" data-cy="wagering-limits-screen">

  <!-- Bet Limit -->
  <div class="limit-row tw-flex tw-items-center tw-justify-between tw-mb-[8px]">
    <span class="limit-label tw-text-[15px]">{{ 'account.preferences.wageringlimits.limit' | translate: 'Bet Limit' }}</span>
    <mat-checkbox
      color="primary"
      [checked]="isWagerLimit"
      [disabled]="isProcessing"
      (change)="toggleCheckbox()"
      data-cy="active-limit"
    ></mat-checkbox>
  </div>

  <mat-form-field appearance="outline" class="tw-w-full">
    <input
      matInput
      type="number"
      amwager3DecimalInput
      [(ngModel)]="wagerLimit"
      (keyup)="onAmount($event)"
      [disabled]="activeBetLimit || isProcessing"
      step="0.01"
      min="0"
      data-cy="wager-limit-input"
    >
  </mat-form-field>

  <!-- Daily Loss Limit (NY only) -->
  <ng-container *ngIf="currentState === 'NY'">
    <div class="limit-row tw-flex tw-items-center tw-justify-between tw-mt-[16px] tw-mb-[8px]">
      <span class="limit-label tw-text-[15px]">{{ 'account.preferences.wageringlimits.dailylosslimit' | translate: 'Daily Loss Limit' }}</span>
    </div>

    <mat-form-field appearance="outline" class="tw-w-full">
      <input
        matInput
        type="number"
        amwager3DecimalInput
        [(ngModel)]="wagerDailyLossLimit"
        (keyup)="onDailyLossLimitAmount($event)"
        [disabled]="isProcessing"
        step="0.01"
        min="0"
        data-cy="daily-loss-limit-input"
      >
    </mat-form-field>

    <p
      *ngIf="pendingLossLimitEffective && isTriggeredDailyLoss"
      class="pending-note tw-text-[13px] tw-mt-[4px]"
      data-cy="daily-loss-pending"
    >
      {{
        'ui.account.new.limit.effective'
          | translate: '' : {
              amount: pendingLossLimit,
              date: (pendingLossLimitEffective | dateFormat: 'MMMM DD, YYYY')
            }
      }}
    </p>
  </ng-container>

</section>
